import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-text-viewer',
  templateUrl: './text-viewer.component.html',
  styles: ''
})
export class TextViewerComponent {

  constructor(private route: ActivatedRoute) {
    this.route.queryParams.subscribe(params => {
      // Access query parameters here
      if (params['text'] != undefined) {
        let storageName = params['text'];
        let text = localStorage.getItem(storageName);
        if (text != null) {
          this.text = text;
        }
        localStorage.removeItem(storageName);
      }
    });
  }

  public text = "";
}
